import request from '@/utils/request';



export function login(data) {
    return request({
        method: 'post',
        url: '/authentication/login',
        data
    })
}
export function logout(data) {
    return request({
        method: 'post',
        url: '/authentication/logout',
        data
    })
}
export function signup(data) {
    return request({
        method: 'post',
        url: '/authentication/signup',
        data
    })
}
export function forgotPassword(data) {
    return request({
        method: 'post',
        url: '/authentication/forgot_password',
        data
    })
}
export function resetPassword(data) {
    return request({
        method: 'post',
        url: '/authentication/reset_password',
        data
    })
}
// Replaces a support-issued one-time password. Unauthenticated on purpose — login
// refuses to hand out a token while one is outstanding, so the temporary password
// is the only credential available.
export function rotatePassword(data) {
    return request({
        method: 'post',
        url: '/authentication/password/rotate',
        data
    })
}
export function getTimezoneList(unused_data) {
    return request({
        method: 'get',
        url: '/timezones',
    })
}
export function updateProfile(data) {
    return request({
        method: 'post',
        url: '/profile/update',
        data
    })

}
export function validateEmail(data) {
    return request({
        method: 'post',
        url: '/authentication/email/validate',
        data
    })
}
export function sendEmailVerification(data) {
    return request({
        method: 'post',
        url: '/authentication/email/verification/send',
        data,
        // Cooldown / already-verified are handled inline on the verify page.
        silent: true
    })
}
export function confirmEmailVerification(data) {
    return request({
        method: 'post',
        url: '/authentication/email/verification/confirm',
        data,
        // Wrong-code errors render inline under the code cells, not as toasts.
        silent: true
    })
}
/*---------------------------system config-------------------------*/
export function getSystemConfig(data) {
    return request({
        url: '/system_configs/',
        method: 'post',
        data
    })
}

// send feedback
export function sendFeedback(data) {
    return request({
        url: '/requests/create',
        method: 'post',
        data
    })
}

export function getLanguages(data) {
    return request({
        method: 'get',
        url: '/languages',
        data
    })
}